module.exports = __webpack_public_path__ + "static/media/trusted-niftem.cf55060d.png";